var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollaboration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6668 11.2501H32.0187C31.0168 11.2501 30.5158 11.2501 30.0435 11.107C29.5712 10.964 29.1543 10.6862 28.3207 10.1304C27.0703 9.2968 25.6438 8.34583 24.9352 8.13128C24.2267 7.91675 23.4752 7.91675 21.9723 7.91675C19.9287 7.91675 18.6113 7.91675 17.6925 8.29735C16.7737 8.67795 16.0511 9.40053 14.6059 10.8457L13.3341 12.1175C13.0085 12.4432 12.8456 12.606 12.7451 12.7668C12.3724 13.3628 12.4137 14.1285 12.8483 14.6809C12.9656 14.83 13.145 14.9743 13.5038 15.2631C14.8301 16.3305 16.7422 16.2239 17.9432 15.0158L20.0002 12.9465H21.6668L31.6668 23.006C32.5873 23.932 32.5873 25.4332 31.6668 26.3592C30.7463 27.2852 29.254 27.2852 28.3335 26.3592L27.5002 25.5209M27.5002 25.5209L22.5002 20.4912M27.5002 25.5209C28.4207 26.4469 28.4207 27.9482 27.5002 28.874C26.5797 29.8 25.0873 29.8 24.1668 28.874L22.5002 27.1975M22.5002 27.1975C23.4207 28.1234 23.4207 29.6247 22.5002 30.5507C21.5797 31.4765 20.0873 31.4765 19.1668 30.5507L16.6668 28.0357M22.5002 27.1975L19.1668 23.8642M16.6668 28.0357L15.8335 27.1975M16.6668 28.0357C17.5873 28.9617 17.5873 30.463 16.6668 31.389C15.7464 32.3149 14.254 32.3149 13.3335 31.389L8.62745 26.5849C7.66041 25.5977 7.1769 25.1042 6.55741 24.8437C5.93793 24.5834 5.24696 24.5834 3.86506 24.5834H3.3335",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 24.5833H32.5",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 11.25H3.3335",
    stroke: "#493158",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboration);
export default __webpack_public_path__ + "static/media/Collaboration.1b54c49086a9bc3fa64d6fedc328eaf0.svg";
export { ForwardRef as ReactComponent };